import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhoWeServe() {
  const columns = [['Healthcare Professionals', 'Educators & School Staff', 'Childcare Providers', 'Financial Services'], ['Government Employees', 'Legal Professionals', 'Real Estate Agents', 'Security Personnel'], ['Corporate Teams (5+)', 'Adoption Applicants', 'Volunteers & Non-Profits', 'Licensing Applicants']];
  return <section className="py-12 lg:py-20 bg-white border-b border-slate-100" aria-labelledby="who-we-serve-heading" data-id="element-295">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296">
        <div className="text-center mb-16 lg:mb-20" data-id="element-297">
          <h2 id="who-we-serve-heading" className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight" data-id="element-298">
            Who We Serve
          </h2>
          <div className="w-16 h-1.5 bg-[#4AA6CF] mx-auto rounded-full mb-8" aria-hidden="true" data-id="element-299"></div>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-300">
            Trusted by individuals and organizations across Maryland for
            compliant, professional fingerprinting services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-301">
          {columns.map((column, colIndex) => <motion.div key={colIndex} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: colIndex * 0.15
        }} className="bg-slate-50 rounded-2xl p-8 border border-slate-200 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500" data-id="element-302">
              <ul className="space-y-4" role="list" data-id="element-303">
                {column.map((item, itemIndex) => <li key={itemIndex} className="flex items-center gap-3 text-[#1E1F55]" data-id="element-304">
                    <span className="flex items-center justify-center w-6 h-6 rounded-full bg-[#4AA6CF]/10 flex-shrink-0" aria-hidden="true" data-id="element-305">
                      <CheckIcon className="h-3.5 w-3.5 text-[#4AA6CF]" data-id="element-306" />
                    </span>
                    <span className="font-medium" data-id="element-307">{item}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}